import { useState } from "react";
import { Check, Copy, MessageSquareText, Share2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useFetch } from "@/lib/hooks";
import { Panel } from "@/components/admin/AdminLayout";

const btn = "inline-flex h-12 flex-1 items-center justify-center gap-2 rounded-md px-4 text-base font-semibold transition-colors";

export const GetReviewsBox = () => {
  const { data } = useFetch(() => api.get("/admin/settings"), []);
  const [copied, setCopied] = useState(false);
  const link = `${window.location.origin}/review`;
  const name = data?.name;
  const message = `Thanks for choosing ${name}! We'd love a quick review — it really helps our small shop: ${link}`;
  const canShare = typeof navigator !== "undefined" && typeof navigator.share === "function";

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
    } catch {
      const t = Object.assign(document.createElement("textarea"), { value: link });
      document.body.appendChild(t);
      t.select();
      document.execCommand("copy");
      t.remove();
    }
    setCopied(true);
    toast.success("Link copied");
    setTimeout(() => setCopied(false), 2500);
  };
  const share = () => navigator.share({ title: `Review ${name}`, text: message, url: link }).catch(() => {});

  return (
    <Panel title="Get more reviews" testId="get-reviews-box">
      <p className="text-sm text-zinc-400">Send this link to happy customers so they can leave a review.</p>
      <p className="mt-3 break-all rounded-md border border-zinc-700 bg-[#121214] px-3 py-3 font-mono text-sm text-[#FFD23F]" data-testid="review-link-text">{link}</p>
      {name && <div className="mt-3 flex flex-wrap gap-2">
        <a href={`sms:?&body=${encodeURIComponent(message)}`} className={`${btn} bg-[#FFD23F] text-[#121214] hover:bg-[#ffdd66]`} data-testid="review-link-text-it-button">
          <MessageSquareText className="h-5 w-5" /> Text it
        </a>
        <button type="button" onClick={copy} className={`${btn} border border-zinc-700 text-zinc-100 hover:bg-zinc-800`} data-testid="review-link-copy-button">
          {copied ? <Check className="h-5 w-5 text-[#7ee08a]" /> : <Copy className="h-5 w-5" />} {copied ? "Link copied" : "Copy link"}
        </button>
        {canShare && (
          <button type="button" onClick={share} className={`${btn} border border-zinc-700 text-zinc-100 hover:bg-zinc-800`} data-testid="review-link-share-button">
            <Share2 className="h-5 w-5" /> Share
          </button>
        )}
      </div>}
    </Panel>
  );
};
